import {getPaymentLink} from "@/api/Orders/GetPaymentLink";
import {createOrder} from "@/api/Orders/CreateOrder";
import {getOrderStatusByCourseId} from "@/api/Orders/GetOrderStatusByCourseId";
import {getOrderStatus} from "@/api/Orders/GetOrderStatus";

export default {
    actions: {
        fetchPaymentLink: async ({commit}, {locationId, orderIdentifier, origin}) => {
            const paymentLink = await getPaymentLink(locationId, orderIdentifier, origin)
            return paymentLink.data
        },
        createOrder: async ({commit}, {locationId, productId, greenCourseId}) => {
            const order = await createOrder(locationId, productId, greenCourseId);
            return order.data
        },
        getOrderStatus: async ({commit}, {orderIdentifier}) => {
            const status = await getOrderStatus(orderIdentifier)
            return status.data
        },
        getOrderStatusByCourseId: async ({commit}, {courseId}) => {
            console.log("courseEndedView", courseId)
            const status = await getOrderStatusByCourseId(courseId)
            return status.data
        }
    }
}

